import { Box, Flex, Image, Text, useBreakpointValue } from '@chakra-ui/react';
import { VdoCipherPlayer } from '@components/VdoCipherPlayer/vdo-cipher-player.tsx';
import { mixPanel } from '@utils/Mixpanel';
import { useEffect, useState } from 'react';

let MargazhiQuote = ({ section }) => {
  const sectionContent = section?.sectionContent;
  const videoId = useBreakpointValue({
    base: sectionContent?.[1]?.mobileVideo,
    md: sectionContent?.[1]?.desktopVideo,
  });
  let aspectRatio = useBreakpointValue({ base: '9/16', md: false });
  let videoHeight = useBreakpointValue({base: 'auto', md: '300px', lg: '450px', xl: '527px', '2xl': '785px'})

  let [showSadhguruBgVideo, setShowSadhguruBgVideo] = useState(true)

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const target = document.getElementById("sadhguruQuote");
    if (!target) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
            setIsVisible(entry.isIntersecting);
        });
      },
      {
        root: null,          // observe relative to viewport
        rootMargin: "0px",   // no margin
        threshold: 0.1,      // 10% visible triggers
      }
    );
    observer.observe(target);
    return () => {
      if (target) observer.unobserve(target);
    };
  }, []);

  const mixPanelTrigger = () => {
    const Mixpanel = mixPanel(window?.location.pathname);
    Mixpanel.track('margazhi_video_played', {
      video_name: "Sadhguru Video",
    });
  };

  return (
    <Flex id={'sadhguruQuote'}
      gap={{ base: '30px', md: 'unset' }}
      bgColor={'#F8F1E7'}
      flexDir={{ base: 'column', md: 'row' }}
      justifyContent={'center'}
      alignItems={'center'}
      py={{ base: '80px', lg: '120px', "2xl": '124px' }}
    >
      <Box
        marginLeft={{ base: 'unset', md: 'auto' }}
        width={{ base: 'calc(100% - 32px)', md: '350px', xl: '455px' }}
        mr={{ base: '0px', md: '1rem', xl: '2rem' }}
        borderLeft={'2px solid #CF4520'}
        pl={{ base: '1rem', md: '1rem' }}
        mx={"16px"}
      >
        <Text
          fontFamily="'FedraSansStd-book-i', sans-serif"
          fontSize={{ base: '18px', md: '22px', xl: '28px' }}
          fontWeight={400}
          lineHeight={{ base: '25.2px', md: '40px', xl: '44.8px' }}
          fontStyle={"italic"}
          letterSpacing={{ base: '0.36px', md: '0.56px' }}
        >
          {sectionContent?.[0]?.quote}
        </Text>
        <Image
          mt={'25px'}
          src="https://static.sadhguru.org/d/46272/1758794931-sadhguru_black_font_sign.svg"
          width={{ base: '76px', md: 'auto' }}
          height={{ base: '36px', md: 'auto' }}
        />
      </Box>
      <Box
        px={{ base: '16px', md: '0px' }}
        width={{ base: '100%', md: '400px', lg: '600px', xl: '703px', '2xl': '1047px' }}
        height={videoHeight}
      >
        <VdoCipherPlayer
        id={videoId + "BgVideo"}
        videoId={videoId}
        aspectRatio={aspectRatio ? aspectRatio : undefined}
        mixPanelTrigger={mixPanelTrigger}
        startVideoInUseEffect={isVisible}
        muteStatus={true}
        controlAutoPlay={showSadhguruBgVideo}
        loopVideo={showSadhguruBgVideo}
        onClick={() => {setShowSadhguruBgVideo(false)}}
        isSadhguruBgVideo={showSadhguruBgVideo}
        hideFullScreen={showSadhguruBgVideo}
        hideDragProgBar={showSadhguruBgVideo}
        showVideoInFullSize={aspectRatio ? false : true}
        iframeHeight={aspectRatio ? '' : ` height: ${videoHeight}; `}
        wrapperOverFlowHidden={aspectRatio ? false : true}
      />
      </Box>
    </Flex>
  );
};

export default MargazhiQuote;
